import React from 'react';

import { DotLottiePlayer } from '@dotlottie/react-player';

import * as styles from './lottie.module.css';

export function Lottie({ lottieFile }) {
    const {
        lottieFile: file,
        lottieFileURL,
        lottieMaxWidth,
        lottieMaxHeight
    } = lottieFile;

    return (
        <div className={styles.moduleContainer}>
            <DotLottiePlayer
                autoplay
                loop
                src={lottieFileURL || file}
                style={{
                    maxWidth: lottieMaxWidth,
                    maxHeight: lottieMaxHeight
                }}
            />
        </div>
    );
}